import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-243">
        {label && <label htmlFor={inputId} className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-244">
            {label}
          </label>}
        <div className="relative" data-id="element-245">
          {leftIcon && <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400" data-id="element-246">
              {leftIcon}
            </div>}
          <input ref={ref} id={inputId} className={`
            block w-full rounded-xl border transition-all duration-200
            focus:outline-none focus:ring-4 focus:ring-[#2952C4]/10 focus:border-[#2952C4]
            disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed
            placeholder:text-slate-400
            ${error ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500/10 focus:border-red-500' : 'border-slate-200 text-slate-900 hover:border-slate-300'}
            ${leftIcon ? 'pl-10' : 'pl-3.5'}
            ${rightIcon ? 'pr-10' : 'pr-3.5'}
            py-2.5 text-sm shadow-sm
            ${className}
          `} {...props} data-id="element-247" />
          {rightIcon && <div className="absolute inset-y-0 right-0 pr-3.5 flex items-center pointer-events-none text-slate-400" data-id="element-248">
              {rightIcon}
            </div>}
        </div>
        {error && <p className="mt-1.5 text-sm text-red-600 font-medium" data-id="element-249">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-slate-500" data-id="element-250">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';